module.exports = {
      id: "shorts-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#shorts",
      toString: function () {
        return this.url;
      }
    }